import React from "react";
import '../../App.css';

export default function Services() {
  return (
    <div className="services">
      <h1>SERVICES</h1>
    </div>
  )
}